import { Directive, inject } from '@angular/core';
import { TouchCapabilityService } from 'src/app/shared/services/touch-capability.service';

@Directive({
  selector: '[rv-draggable-handle]',
  standalone: false,
  host: {
    class: 'rv-draggable-handle',
    'aria-hidden': 'true',
    '[class.rv-draggable-handle--visible]': 'isVisible()',
  },
})
export class RvDraggableHandleDirective {
  protected readonly isVisible = inject(TouchCapabilityService).isTouchCapable;
}
